import { LayerSpecification } from 'maplibre-gl';
import { MapSourceId } from '@daisi/models/map';

/**
 * GeoJSON source and layers for the roadworks map. They mirror the former Martin vector-tile
 * style (assets/map-style/road_works_overview.json) but read from a client-side GeoJSON source
 * fed with the table's displayed rows, so the table filters also filter the map. The
 * geometry-type filters match MultiLineString too (MapLibre normalises it to "LineString").
 */
export const ROADWORKS_SOURCE: MapSourceId = 'roadworks';

export const ROADWORKS_LAYERS: LayerSpecification[] = [
  {
    id: 'roadworks-stroke',
    type: 'line',
    source: ROADWORKS_SOURCE,
    filter: ['==', ['geometry-type'], 'LineString'],
    layout: { 'line-cap': 'butt' },
    paint: {
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 8, 5, 14, 9, 20, 12],
      'line-color': '#ffffff',
      'line-offset': ['interpolate', ['exponential', 1.4], ['zoom'], 8, 1.4, 14, 2.8, 20, 4.5],
    },
  },
  {
    id: 'roadworks-line',
    type: 'line',
    source: ROADWORKS_SOURCE,
    filter: ['==', ['geometry-type'], 'LineString'],
    layout: { 'line-cap': 'butt' },
    paint: {
      'line-width': ['interpolate', ['exponential', 1.4], ['zoom'], 8, 3, 14, 5, 20, 7],
      'line-color': '#a91907',
      'line-dasharray': [1, 0.4],
      'line-offset': ['interpolate', ['exponential', 1.4], ['zoom'], 8, 1.4, 14, 2.8, 20, 4.5],
    },
  },
  {
    id: 'roadworks-arrow',
    type: 'symbol',
    source: ROADWORKS_SOURCE,
    minzoom: 9,
    filter: ['==', ['geometry-type'], 'LineString'],
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': ['interpolate', ['linear'], ['zoom'], 10, 35, 15, 90],
      'text-field': '▶',
      'text-font': ['Noto Sans Regular'],
      'text-size': ['interpolate', ['linear'], ['zoom'], 10, 8, 15, 12, 20, 17],
      'text-rotation-alignment': 'map',
      'text-keep-upright': false,
      'text-allow-overlap': true,
      'text-ignore-placement': false,
    },
    paint: {
      'text-color': '#000000',
      'text-halo-color': '#ffffff',
      'text-halo-width': 2,
    },
  },
  {
    id: 'roadworks-icon',
    type: 'symbol',
    source: ROADWORKS_SOURCE,
    minzoom: 8,
    filter: ['==', ['geometry-type'], 'LineString'],
    layout: {
      'symbol-placement': 'line',
      'symbol-spacing': ['interpolate', ['linear'], ['zoom'], 10, 80, 14, 140, 18, 240],
      'icon-image': 'C2',
      'icon-size': ['interpolate', ['linear'], ['zoom'], 10, 0.7, 15, 1, 20, 1.4],
      'icon-allow-overlap': false,
      'icon-ignore-placement': false,
      'icon-rotation-alignment': 'viewport',
      'symbol-sort-key': 1,
    },
  },
  {
    id: 'roadworks-icon-center',
    type: 'symbol',
    source: ROADWORKS_SOURCE,
    minzoom: 8,
    filter: ['==', ['geometry-type'], 'LineString'],
    layout: {
      'symbol-placement': 'line-center',
      'icon-image': 'C2',
      'icon-size': ['interpolate', ['linear'], ['zoom'], 10, 0.7, 15, 1, 20, 1.4],
      'icon-allow-overlap': false,
      'icon-ignore-placement': false,
      'icon-rotation-alignment': 'viewport',
      'symbol-sort-key': 0,
    },
  },
  {
    id: 'roadworks-point',
    type: 'symbol',
    source: ROADWORKS_SOURCE,
    filter: ['==', ['geometry-type'], 'Point'],
    layout: {
      'icon-image': 'C2',
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
    },
  },
];
